import React from 'react';

// Utils
import { MESSAGES } from '~/utils/message';
import { balanceFormatter } from '~/utils/helperFunctions';

// Components
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

// MUI Components
import { Box, Typography } from '@mui/material';

const { TITLE, BODY, BALANCE_LABEL, COST_LABEL, CONFIRM_BUTTON, CANCEL_BUTTON } =
  MESSAGES.ORDERS.CREATE.INSUFFICIENT_FUNDS_WARNING;

/**
 * Warns an impersonating admin that the customer's wallet does not cover the order.
 * It is only a warning: confirming still places the order.
 */
const InsufficientFundsWarningModal = ({ open, balance, cost, loading, onConfirm, onClose }) => (
  <OlcFormModal
    open={open}
    onClose={onClose}
    title={TITLE}
    footer={
      <>
        <OlcButton variant="secondary" onClick={onClose} disabled={loading}>
          {CANCEL_BUTTON}
        </OlcButton>
        <OlcButton variant="primary" onClick={onConfirm} disabled={loading}>
          {CONFIRM_BUTTON}
        </OlcButton>
      </>
    }
  >
    <Typography>{BODY}</Typography>
    <Box sx={{ mt: 2 }}>
      <Typography>
        {BALANCE_LABEL}: <strong>{balanceFormatter(balance)}</strong>
      </Typography>
      <Typography>
        {COST_LABEL}: <strong>{balanceFormatter(cost)}</strong>
      </Typography>
    </Box>
  </OlcFormModal>
);

export default InsufficientFundsWarningModal;
